import Tabs from './Tabs'
import Tab from './Tab'
import './style/tabs.scss'

Tabs.Tab = Tab

export { Tab }
export default Tabs